// DASHBOARD getters
export default {
  get_activity_graph: (state) => state.activityGraph,
  get_performance_graph: (state) => state.performanceGraph,
  get_carrier_graph: (state) => state.carrierGraph,
  get_map_graph: (state) => state.mapGraph,
  get_deviations_graph: (state) => state.deviationsGraph,
  get_newest_shipment_graph: (state) => state.shipmentsGraph,
  get_dummy_map: (state) => state.dummyMap,
};
